import { create } from 'zustand';
import type { Chain, Token } from '../lib/transfers';

/** A request to re-send a failed transfer. Set from the
 * transaction detail sheet's "Resend" action; consumed by the global mount in App
 * which opens the Send screen prefilled with these values. */
export type ResendReq = { chain: Chain; token: Token; to: string; amount: string };

type ResendState = {
  req: ResendReq | null;
  request: (r: ResendReq) => void;
  clear: () => void;
};

export const useResendStore = create<ResendState>((set) => ({
  req: null,
  request: (req) => set({ req }),
  clear: () => set({ req: null }),
}));
